export enum RouteLang {
    FR = 'fr',
}